<template lang="pug">
  .routes-table
    .routes-table__title.semibold Список маршрутов
    .routes-table__wrapper
      .routes-table__block.routes-table__items
        // верстка маршрутов
        template(v-if="rows && rows.data && rows.data.length")
          .routes-table__item(
            v-for="row in rows.data"
            :key="row.id"
            @click.prevent="showOnMap(row)"
            :class="{'routes-table__item_active': (activeGarbage === row.id)}"
          )
            .routes-table__line №{{row.id}} {{row.tkoObject ? row.tkoObject.name : ' - '}}
            .routes-table__parameters
              .routes-table__parameter.routes-table__number(title='год') {{row.year ? row.year : ' - '}}
              .routes-table__parameter.routes-table__weight(:style='{color: row.color}') {{row.total}} тонн
              .routes-table__parameter.routes-table__distance {{transformDistance(row)}}

        template(v-else-if="loading")
          .routes-line
            p Загрузка...

        template(v-else)
          .routes-line
            p Нет маршрутов

      .routes-table__block.routes-table__map-block
        .map(ref="map" id='map' v-once)
        div(v-if="loading")
          p Загрузка...
        div(v-else-if="coordsNotFound")
          p Недостаточно данных для отображения
        div(v-else-if="error")
          p {{error}}
</template>

<script>
import { tko, map } from '@/api/api-endpoints'
import { TILE_LAYER } from '@/config/map'
import RouteDrawer from '@/utils/map/RouteDrawer'
import { OBJECT } from '@/utils/map/types'
import url from '@/utils/url'
import * as L from 'leaflet'
import userFriendlyEr from '@/utils/userFriendlyEr'
import { REGION_CONFIG } from '@/config/regions'

const mapConfig = REGION_CONFIG.map

export default {
  name: 'routes-table',
  props: {
    id: null,
    tabView: null,
    fields: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    this.map = null
    return {
      operationType: 'output',
      year: 0,
      coordsNotFound: true,
      activeGarbage: null,
      loading: true,
      error: null,
    }
  },
  computed: {
    rows() {
      return this.$store.getters.readUrlEndpoint(this.getEndpoint())
    },
  },
  watch: {
    activeGarbage: function () {
      let route = url.getRoute(this.$route)
      route.query.activeGarbage = this.activeGarbage
      this.$router.replace(route)
    },
    loading: function (newVal) {
      if (newVal === true) {
        this.$bar.start()
      } else {
        this.$bar.finish()
      }
    },
  },
  methods: {
    transformDistance(model = {}) {
      if (!model.geoRoute) {
        model.geoRoute = {}
      }
      let {
        geoRoute: { distance = 0 },
      } = model
      if (distance) {
        distance = distance / 1000
        distance = distance.toFixed(2)
      } else {
        distance = 0
      }
      return `${distance} км`
    },
    initMap() {
      this.map = L.map(this.$refs.map, {
        center: mapConfig.center,
        zoom: mapConfig.zoom,
        minZoom: mapConfig.minZoom,
        contextmenu: false,
        preferCanvas: false,
      })
      L.tileLayer(TILE_LAYER, {}).addTo(this.map)
      this.routeDrawer = new RouteDrawer(this.map, this)
    },
    showOnMap(model = {}) {
      if (model.id === this.activeGarbage) {
        return
      }

      this.routeDrawer.removeAllObjects()
      this.activeGarbage = model.id
      // for prevent mutation
      const { tkoObject = {} } = JSON.parse(JSON.stringify(model))
      const tkoObjectSource = Object.assign({}, this.fields)
      let tkoObjects = [
        Object.assign(tkoObjectSource, {
          type: OBJECT.TKO,
          lat: tkoObjectSource.latitude,
          lng: tkoObjectSource.longitude,
        }),
      ]
      // @fix: lat or latitude
      if (tkoObject) {
        tkoObject.lat = tkoObject.lat || tkoObject.latitude
        tkoObject.lng = tkoObject.lng || tkoObject.longitude
      }
      if (tkoObject && tkoObject.lat && tkoObject.lng && model.geo_route_id) {
        tkoObjects.push(
          Object.assign(tkoObject, {
            type: OBJECT.TKO,
            lat: tkoObject.lat,
            lng: tkoObject.lng,
          })
        )
        this.routeDrawer.setTkoObjects(tkoObjects)
        this.coordsNotFound = false
        const endpoint = map.route(model.geo_route_id)
        this.loading = true
        this.error = null
        this.$store
          .dispatch('updateUrlEndpoint', {
            endpoint,
            params: {
              disableGlobalError: true,
            },
          })
          .then((r) => {
            let {
              data: { geo_json },
            } = r
            this.routeDrawer.setGeoJson({ name: 'route', geo_json })
            this.loading = false
          })
          .catch((e) => {
            this.error = userFriendlyEr.recognize(e)
            this.coordsNotFound = true
            this.loading = false
          })
      } else {
        this.coordsNotFound = true
        this.routeDrawer.removeAllObjects()
      }
    },
    registerClosePopup() {},
    registerOpenPopup() {},
    getEndpoint() {
      if (!this.id) {
        return null
      }

      let routeQuery = {
        query: {
          sourceId: this.id,
          year: this.year,
          type: this.operationType,
        },
      }

      return tko.objectGarbageOperation(routeQuery)
    },
    fetchData() {
      const endpoint = this.getEndpoint()
      if (endpoint) {
        this.loading = true
        this.$store
          .dispatch('updateUrlEndpoint', { endpoint: endpoint })
          .then(() => {
            this.loading = false
            if (this.rows && this.rows.data && this.rows.data.length) {
              let model = this.rows.data[0]
              if (this.activeGarbage) {
                let foundIndex = this.rows.data.findIndex(
                  (v) => +v.id === +this.activeGarbage
                )
                if (foundIndex > -1) {
                  model = this.rows.data[foundIndex]
                }
              }
              this.showOnMap(model)
            } else {
              this.coordsNotFound = true
              this.routeDrawer.removeAllObjects()
            }
            this.$refs.ps.update()
          })
          .catch(() => {
            this.loading = false
            this.coordsNotFound = true
          })
      } else {
        this.loading = false
        this.coordsNotFound = true
      }
    },
  },
  mounted() {
    this.initMap()
  },
  created() {
    if (this.$route.query && this.$route.query.activeGarbage) {
      this.activeGarbage = this.$route.query.activeGarbage
    }
    this.fetchData()
  },
}
</script>
